import { mark } from "../i18n";

// Password policy: 8-20 characters, at least one uppercase letter and at
// least one special (non-alphanumeric) character.
export const PASSWORD_RULES = [
  { id: "length", label: mark("8-20 characters"), test: (p) => p.length >= 8 && p.length <= 20 },
  { id: "upper", label: mark("One uppercase letter (A-Z)"), test: (p) => /[A-Z]/.test(p) },
  { id: "special", label: mark("One special character (!@#$…)"), test: (p) => /[^A-Za-z0-9\s]/.test(p) },
];

export function checkPassword(password) {
  const results = PASSWORD_RULES.map((r) => ({ ...r, ok: r.test(password || "") }));
  return { results, valid: results.every((r) => r.ok) };
}
